/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export function isLatLngInUS(
    lat: number | null | undefined,
    lng: number | null | undefined
): boolean {
    if (!lat || !lng) {
        return false; // Invalid coordinates
    }

    // Continental US (excluding Alaska and Hawaii)
    const isInContinentalUS =
        lat >= 24.396308 && lat <= 49.384358 && lng >= -125.0 && lng <= -66.93457;

    // Alaska
    const isInAlaska =
        lat >= 51.2097 && lat <= 71.3651 && lng >= -179.1489 && lng <= -129.9795;

    // Hawaii
    const isInHawaii = lat >= 18.5 && lat <= 22.5 && lng >= -160.24 && lng <= -154.8;

    return isInContinentalUS || isInAlaska || isInHawaii;
}

// Helper function to extract location details and fallback to a default location.
export function getLocationWithFallback(geo?: {
    latitude?: number | null;
    longitude?: number | null;
    city?: string | null;
    region_name?: string | null;
    source?: string | null;
}) {
    const defaultLocation = {
        latitude: 38.89511,
        longitude: -77.03637,
        location: 'Washington, DC',
    } as const;

    const isInUS = isLatLngInUS(geo?.latitude, geo?.longitude);
    const latitude = isInUS && geo?.latitude ? geo.latitude : defaultLocation.latitude;
    const longitude =
        isInUS && geo?.longitude ? geo.longitude : defaultLocation.longitude;

    const location = !isInUS
        ? defaultLocation.location
        : isInUS && geo?.city && geo?.region_name
          ? `${geo.city}, ${geo.region_name}`
          : undefined;
    return { latitude, longitude, location, isInUS };
}
